﻿{
  "registration": {
    "sectionTitle": "WACHTPOST",
    "title": "Registratie",
    "firstName": "Voornaam",
    "lastName": "Achternaam",
    "company": "Transportbedrijf",
    "companyPlaceholder": "Typ 3 letters om te zoeken...",
    "plate": "Kenteken",
    "orderNumber": "Bestelnummer",
    "photo": "Foto bestuurder",
    "takePhoto": "Maak een foto",
    "chooseFile": "Bestand kiezen",
    "security": "Ik heb het veiligheidsprotocol van de site gelezen en geaccepteerd",
    "securitySub": "PBM verplicht · Verboden zones · Max. snelheid 10 km/h",
    "submit": "Registratie bevestigen",
    "success": "Registratie succesvol voltooid",
    "qrInstruction": "Scan deze QR-code om de plattegrond en diensten van de site te openen op uw telefoon of tablet.",
    "qrDone": "Registratie voltooid",
    "nextRegistration": "Volgende registratie",
    "errorRequired": "Dit veld is verplicht",
    "errorSecurity": "U moet het veiligheidsprotocol accepteren",
    "phone": "Telefoonnummer",
    "phonePlaceholder": "+31 6 12345678",
    "tankCapacity": "Tankinhoud (liter)",
    "tankCapacityPlaceholder": "Bijv. 26000",
    "baffles": "Schotten",
    "bafflesYes": "Ja",
    "bafflesNo": "Nee",
    "tare": "Leeggewicht voertuig (kg)",
    "tarePlaceholder": "Bijv. 14500",
    "washCertificate": "Reinigingscertificaat",
    "washWashed": "Gereinigd",
    "washNotWashed": "Niet gereinigd",
    "adr": "ADR-conformiteit",
    "adrCompliant": "Conform",
    "adrNotCompliant": "Niet conform",
    "groupContact": "Contact",
    "groupVehicle": "Voertuig en Tank",
    "groupCompliance": "Conformiteit",
    "groupSecurity": "Veiligheid",
    "securityProtocol": "Veiligheidsprotocol van het terrein",
    "groupMedia": "Media",
    "fieldOptional": "Optioneel",
    "fieldRequired": "Verplicht",
    "wizardStepLabel": "Stap",
    "wizardStep1Title": "Welke handeling voert u uit?",
    "wizardStep1Subtitle": "Selecteer het type interventie op de site",
    "wizardExpedition": "Expeditie",
    "wizardLivraison": "Levering",
    "wizardStep2Title": "Bestelnummer",
    "wizardOrderLabel": "Bestelnummer",
    "wizardOrderHintExpedition": "Voorbeeld: AR… of 5…",
    "wizardOrderHintLivraison": "Voorbeeld: 85…",
    "wizardOrderError": "Ongeldig formaat voor dit type handeling",
    "wizardOrderUnknown": "Ik heb / ken het bestelnummer niet",
    "wizardOrderPlanned": "Geplande bestelling gevonden — velden vooraf ingevuld",
    "wizardValidate": "Bevestigen",
    "wizardBack": "Terug",
    "wizardStep3Title": "Welk type voertuig bestuurt u?",
    "wizardStep3Subtitle": "Selecteer uw voertuig",
    "wizardTank": "Tankwagen",
    "wizardTrailer": "Oplegger",
    "wizardModalIso": "ISO-tank?",
    "wizardModalContainer": "Container?",
    "wizardYes": "JA",
    "wizardNo": "NEE",
    "chassisPlate": "ISO-nummer",
    "containerPlate": "Containernummer",
    "tareIso": "ISO-tarra (kg)",
    "tareContainer": "Containertarra (kg)",
    "pinTitle": "Pincode",
    "pinError": "Onjuiste code",
    "pinCancel": "Annuleren",
    "capturePhoto": "Vastleggen",
    "guardAccess": "Toegang bewaking",
    "trailerPlate": "Opleggerplaat"
  },
  "driver": {
    "title": "Welkom op het terrein",
    "subtitle": "Volg de instructies van de wachtpost",
    "yourPosition": "Uw positie",
    "enableGps": "Locatie inschakelen",
    "gpsActive": "Locatie actief",
    "gpsError": "Locatie niet beschikbaar",
    "gpsPermission": "Sta locatietoegang toe",
    "helpBtn": "Ik heb hulp nodig",
    "helpSent": "Hulpverzoek verzonden",
    "helpAlready": "Uw verzoek is ontvangen",
    "sessionExpired": "Sessie beëindigd",
    "sessionExpiredMsg": "Uw sessie is verlopen. Bedankt voor uw bezoek.",
    "waitingMsg": "Een moment geduld, een medewerker zal u spoedig helpen",
    "estimatedPassage": "Geschatte doorrijtijd",
    "instruction": "Instructie",
    "instructionClose": "Sluiten"
  },
  "incident": {
    "alertTitle": "ALARM — ONMIDDELLIJK EVACUEREN",
    "alertSubtitle": "Volg onmiddellijk de aanwijzingen op de kaart",
    "alertInstruction": "Ga naar het dichtstbijzijnde verzamelpunt",
    "safeNow": "Ik ben veilig",
    "normalMode": "Situatie terug normaal",
    "evacuation": "Evacuatiepunt",
    "assembly": "Verzamelpunt",
    "firstAid": "Eerste hulp"
  },
  "messages": {
    "title": "Bericht van de operator",
    "placeholder": "Schrijf een bericht aan de chauffeur...",
    "send": "Verzenden",
    "dictate": "Dicteren",
    "translatedTo": "Vertaald naar",
    "noMessages": "Geen berichten verzonden",
    "reactionSent": "Reactie verzonden"
  }
}
